import { Component, Input } from '@angular/core';

@Component({
    selector: 'cmps-insight-coaching-progress-bar',
    template: `
        <div class="cmps-insight-coaching-progress-bar--row">
            <div class="cmps-insight-coaching-progress-bar--column">
                <p class="cmps-insight-coaching-progress-bar--label">
                    {{ progressLabelValue }}
                </p>
            </div>

            <div class="cmps-insight-coaching-progress-bar--column">
                <p class="cmps-insight-coaching-progress-bar--label">
                    {{ progressPercentValue }}
                </p>
            </div>

            <div class="cmps-insight-coaching-progress-bar--column">
                <div class="cmps-insight-coaching-progress-bar--progress-bar">
                    <div
                        class="cmps-insight-coaching-progress-bar--progress-bar-filled"
                        [style.width]="progressPercentValue"
                        [style.backgroundColor]="progressBarColor"
                    ></div>
                </div>
            </div>
        </div>
    `,
    host: {
        class: 'cmps-insight-coaching-progress-bar',
    },
})
export class CmpsInsightCoachingProgressBarComponent {
    @Input() progressLabelValue: string;
    @Input() progressPercentValue: string;
    @Input() progressBarColor: string;
}
